<template>
  <kst-print-table :data="receiveList">
    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-shortdate"
      field="ReceiveDate"
      :label="DbpyRcvCatalog.ReceiveDate.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="DbpyRcvCatalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      field="ReceiveID"
      :label="DbpyRcvCatalog.ReceiveID.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="DbpyRcvCatalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      field="VendorID"
      :label="DbpyRcvCatalog.VendorID.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="DbpyRcvCatalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      field="WarehouseID"
      :label="DbpyRcvCatalog.WarehouseID.PrintLabel"
    >
      <kst-value :field="column.field" :data="row" :catalog="DbpyRcvCatalog"/>
    </b-table-column>

    <b-table-column numeric
      v-slot="{ column, row }"
      cell-class="ks-col-price"
      field="PaymentValue"
      :label="DbpyRcvCatalog.PaymentValue.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="DbpyRcvCatalog"/>
    </b-table-column>
  </kst-print-table>
</template>

<script>
import DbpyRcvCatalog from "../DbpyRcvCatalog.js";

export default {
  props: {
    receiveList: Array
  },
  data: () => ({
    DbpyRcvCatalog: DbpyRcvCatalog
  })
}
</script>